export default {"src":"/_next/static/media/icon-globe.23ec5bd0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};